(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-hero"] && !Shopify.designMode) return;
  try {
    (()=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;const init=()=>{const nodes=document.querySelectorAll('.aa>*,.ac>*,.ap>*,.aj>*,.ads>header,.ads-chapter,.ak>*,.acl>*,.dp-left,.dp-right');const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('atelier-motion-visible');observer.unobserve(entry.target)}}),{threshold:.1,rootMargin:'0px 0px -7%'});nodes.forEach(node=>{if(node.dataset.atelierMotion)return;node.dataset.atelierMotion='true';node.classList.add('atelier-motion-item');observer.observe(node)});const hero=document.querySelector('.ah-hero');const media=hero&&hero.querySelector('.ah-hero__media');if(media&&!media.dataset.bohoParallax){media.dataset.bohoParallax='true';let pending=false;const move=()=>{pending=false;const r=hero.getBoundingClientRect();if(r.bottom<0||r.top>innerHeight)return;const offset=Math.max(-90,Math.min(90,-r.top*0.2));media.style.setProperty('--boho-parallax',offset.toFixed(1)+'px')};addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(move)}},{passive:true});move()}};init();document.addEventListener('shopify:section:load',init)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["harbor-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initAtelier = (root) => {
    if (!root || root.dataset.motionReady === 'true') return;
    root.dataset.motionReady = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const targets = root.querySelectorAll('.atelier-intro > *, .atelier-duo__card, .atelier-market header, .atelier-products article, .atelier-origin > *, .atelier-chronicle > header, .atelier-chronicle__image, .atelier-chronicle__chapters article, .atelier-serve > *, .atelier-closing > *');
    targets.forEach((item) => {
      item.classList.add('atelier-reveal');
      if (item.matches('.atelier-duo__card, .atelier-chronicle__image, .atelier-closing__image')) item.classList.add('atelier-reveal--image');
    });
    root.classList.add('is-motion-ready');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    targets.forEach((item) => observer.observe(item));
  };
  document.querySelectorAll('.atelier').forEach(initAtelier);
  document.addEventListener('shopify:section:load', (event) => initAtelier(event.target.querySelector('.atelier')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
